<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve"
       version="1.1"
       style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
       viewBox="0 0 3658 3344"
       xmlns:xlink="http://www.w3.org/1999/xlink">
 <g id="Vrstva_x0020_1">
  <metadata id="CorelCorpID_0Corel-Layer" />
   <path class="fil0"
         d="M409 1774c13,65 4,287 3,366l0 742c0,184 -20,324 144,424 41,25 92,36 149,36l2234 2c131,-1 204,-53 255,-126 65,-93 50,-194 49,-321 -3,-372 5,-749 1,-1123 164,-5 312,21 384,-102 87,-148 -35,-262 -109,-321 -15,-12 -14,-13 -31,-28 -13,-12 -20,-14 -33,-26l-465 -395c-9,-100 1,-211 -3,-313 -3,-89 -55,-175 -100,-208 -79,-60 -124,-67 -245,-67 -186,0 -171,43 -245,75l-333 -284c-138,-126 -315,-144 -442,-24l-748 640c-18,13 -23,20 -40,34l-129 109c-31,25 -52,47 -83,72 -110,89 -546,459 -582,510 -80,115 -34,257 80,306 72,31 205,23 289,22z" />
   <path class="fil1"
         d="M871 1569l131 131c27,-17 45,-40 75,-64 421,-332 973,-365 1414,-65 64,44 146,119 167,131 12,-18 44,-45 62,-63 13,-12 21,-20 34,-32l31 -38c-41,-48 -125,-115 -184,-153 -487,-314 -1057,-322 -1540,-3 -39,25 -63,43 -98,72 -27,21 -77,63 -92,84z" />
   <path class="fil1"
         d="M1132 1836c16,29 102,102 130,131 53,-33 87,-93 234,-157 211,-92 443,-96 656,-4 153,66 208,141 239,160 21,-17 44,-42 66,-63l65 -67c-144,-171 -440,-285 -689,-286 -156,-1 -281,32 -409,85 -89,37 -204,113 -274,179l-18 22z" />
   <path class="fil1"
         d="M1375 2117c29,29 109,117 142,128 24,-33 81,-71 130,-91 54,-22 118,-38 186,-37 197,2 288,115 319,126 28,-24 44,-45 63,-63 23,-23 38,-41 64,-62 -28,-47 -125,-106 -187,-133 -177,-77 -354,-75 -532,1 -65,27 -158,92 -185,131z" />
   <path class="fil1" d="M1775 2316c-260,76 -148,437 107,371 261,-68 142,-444 -107,-371z" />
 </g>
</svg>
</template>

<script>
export default {
  name: 'System',
};
</script>

<style scoped>
.fil1 {
  fill: #FEFEFE
}

.fil0 {
  fill: #56D6D1
}
</style>
